<style lang="scss" scoped>
.print-ag {
  text-align: left;
}

#printInstance {
  width: 1000px;
  padding-left: 160px;
  padding-top: 100px;
  box-sizing: border-box;

  table {
    width: 100%;
    border: 1px solid #52586e;
    border-collapse: collapse;
    margin-bottom: 10px;
  }

  table tr td {
    font-size: 24px;
    line-height: 28px;
    padding: 10px 0 10px 10px;
    border: 1px solid #52586e;
  }

  .container {
    padding: 0 10px;
  }

  // .el-table {
  //   font-size: 24px;
  //   font-weight: 540;
  // }

  // .el-table th > .cell {
  //   font-size: 24px;
  // }
  // // table边框颜色
  // .el-table--border:after,
  // .el-table--group:after,
  // .el-table:before {
  //   background-color: #52586e;
  // }

  // .el-table--border,
  // .el-table--group {
  //   border-color: #52586e;
  // }

  // .el-table td,
  // .el-table th.is-leaf {
  //   border-bottom: 1px solid #52586e;
  // }

  // .el-table--border th,
  // .el-table--border th.gutter:last-of-type {
  //   border-bottom: 1px solid #52586e;
  // }

  // .el-table--border td,
  // .el-table--border th {
  //   border-right: 1px solid #52586e;
  // }

  // .el-table .cell {
  //   line-height: 30px;
  // }

  .title {
    padding-left: 10px;
    color: #52586e;
    font-size: 26px;
    font-weight: 550;
    line-height: 48px;
  }

  .approve-list {
    padding-left: 10px;
    color: #52586e;
    font-size: 24px;
    line-height: 48px;
    border-left: 1px solid #52586e;
    border-right: 1px solid #52586e;
    border-bottom: 1px solid #52586e;

    &:nth-child(2) {
      border-top: 1px solid #52586e;
    }
  }
}
</style>
<template>
  <div class="print-file">
    <div class="print-ag">
      <el-button type="primary" size="small" v-print="'#printInstance'" plain>打印审批记录
      </el-button>
    </div>
    <div id="printInstance">
      <div class="container">
        <div class="common-part">
          <div class="title">基本信息</div>
          <table>
            <tr v-for="(item,index) in printData.base" :key="item.title+index">
              <td>{{item.title}}</td>
              <td>{{item.content}}</td>
            </tr>
          </table>
          <!-- <el-table
            :data="printData.base"
            :show-header="false"
            border>
            <el-table-column
              prop="title"
              width="200">
            </el-table-column>
            <el-table-column
              prop="content">
            </el-table-column>
          </el-table> -->
        </div>
        <div>
          <div class="title">表单信息</div>
          <div class="reimbursement"
            v-if="printData.instanceFormType =='applayReimbursement'">
            <table>
              <tr v-for="(item,index) in printData.applayReimbursement"
                :key="item.name+index">
                <td>{{item.name}}</td>
                <td>{{item.content}}</td>
              </tr>
            </table>
            <!-- <el-table
              :data="printData.applayReimbursement"
              :show-header="false"
              border
              style="width: 100%;">
              <el-table-column
                prop="name"
                width="200">
              </el-table-column>
              <el-table-column
                prop="content">
              </el-table-column>
            </el-table> -->
            <table>
              <thead>
                <tr>
                  <td>报销类型</td>
                  <td>单项金额</td>
                  <td>单项税额</td>
                  <td>日期</td>
                  <td>提示</td>
                  <td>备注</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in printData.applayReimbursementTable1"
                  :key="item.name +index">
                  <td>{{item.name}}</td>
                  <td>{{item.money}}</td>
                  <td>{{item.sum_tax_amount}}</td>
                  <td>{{item.created_at}}</td>
                  <td>{{item.error_msg}}</td>
                  <!-- <td>dow经常我就哦参加哦我参加哦我就从我家哦成为从我的我加哦就发文件都叫我二季度</td> -->
                  <td>{{item.remark}}</td>
                </tr>
              </tbody>
            </table>

            <table>
              <thead>
                <tr>
                  <td>报销类型</td>
                  <td>金额</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in printData.applayReimbursementTable2"
                  :key="item.name +index">
                  <td>{{item.name}}</td>
                  <td>{{item.money}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="applayReserveFunds"
            v-else-if="printData.instanceFormType =='applayReserveFunds'">
            <table>
              <tr v-for="(item,index) in printData.applayReserveFunds"
                :key="item.title+index">
                <td>{{item.title}}</td>
                <td>{{item.content}}</td>
              </tr>
            </table>
            <!-- <el-table
              :data="printData.applayReserveFunds"
              :show-header="false"
              border
              style="width: 100%;">
              <el-table-column
                prop="title"
                width="200">
              </el-table-column>
              <el-table-column
                prop="content">
              </el-table-column>
            </el-table> -->
          </div>
          <div class="applySpendMoney"
            v-else-if="['adApplySpendMoney', 'pdApplySpendMoney','costApplySpendMoney','fixedApplySpendMoney','earnestApplySpendMoney','clientRefund','taxApplySpendMoney','insideTransferMoney'].includes(printData.instanceFormType)">
            <table>
              <tr v-for="(item,index) in printData.applySpendMoney"
                :key="item.title+index">
                <td>{{item.title}}</td>
                <td>{{item.content}}</td>
              </tr>
            </table>

          </div>
          <div class="confirmCost"
            v-else-if="printData.instanceFormType =='confirmCost'">
            <table>
              <tr v-for="(item,index) in printData.confirmCost"
                :key="item.title+index">
                <td>{{item.title}}</td>
                <td>{{item.content}}</td>
              </tr>
            </table>

          </div>
        </div>
        <div>
          <div class="title">审批进程</div>
          <div class="approve-list" v-for="item in printData.approve" :key="item.id">
            <span v-for="task in item.task_list" :key="task.id">
              <span>{{task.username}}--</span>
              <span>{{task.status}}--</span>
              <span>{{task.end_time}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'btnPrintFile',
  data() {
    return {
      printShow: false,
      type: null,
      printData: {}
    }
  },
  /*   
     id: '1',
     name: '报销',
     id: '2',
     name: '备用金(个人借款)',
     id: '3',
     name: '用款申请（行政)',
     id: '4',
     name: '用款申请（采购）',
     id: '5',
     name: '用款申请（费用）',
     id: '6',
     name: '用款申请（固定资产）', 
     */

  created() {
    let printData = JSON.parse(sessionStorage.getItem('ag-print'));
    this.printData = {
      ...printData
    }
    console.log(this.printData, 'this.print');
  },


}
</script>